const STATES = {
  OPEN: 'OPEN',
  CLOSE: 'CLOSE',
};

export default STATES;



// WEBPACK FOOTER //
// ./src/components/stateful/DropDown/STATES.js